<section class="h-full overflow-hidden">
  <ts-page-header [displaySeparationBorder]="true">
    <span page-header-title class="font-ts-header-title text-ts-header-title">Audit</span>
  </ts-page-header>

  <div class="bg-white h-ts-page-content overflow-hidden flex flex-col justify-between">
    <div class="overflow-auto h-full">
      <audit-list [loading]="loading | async" [activities]="(activitiesPage$ | async)?.results" />
    </div>
    @if (activitiesPage$ | async; as activitiesPage) {
      <ts-paginator
        [pageSize]="activitiesPage.per_page"
        [activePage]="activitiesPage.page"
        [totalItems]="activitiesPage.count"
        (pageChanged)="pageChanged($event)"
      />
    }
  </div>
</section>
